import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'
import globals from '@/plugins/globals'
import store from '@/store'

export default {
  resetInsurance({ commit }) {
    commit(types.RESET_INSURANCE_DATA)
  },
  setInsurance({ commit }, data) {
    commit(types.SET_INSURANCE_DATA, data)
  },
  async setLookups({ commit, dispatch, state }, data) {
    let profile = store.getters['auth/profile']
    let showInactive = false
    if (data.showInactive !== undefined && data.showInactive !== null) {
      showInactive = data.showInactive
    }
    let _keys = data.keys.filter((k) => !state.lookups[k])
    if (data.refresh === undefined || data.refresh === null) {
      data.refresh = false
    }
    if (_keys.length || data.refresh) {
      if (data.firm === undefined || data.firm === null) {
        data.firm = profile.firm
      }
      const r = await startLoading(dispatch, 'setLookups', () =>
        http.post('lookup/ByKeys', {
          keys: data.keys,
          firm: data.firm,
          showInactive: showInactive
        })
      )
      commit(types.SET_LOOKUPS, [data.keys, r.data, showInactive])
    }
  },
  async getLookupsByGroup({ commit, dispatch, state }, { className, group }) {
    const r = await startLoading(dispatch, 'getLookupsByGroup', () => http.get(`lookup/ByGroup?className=${className}&group=${group}`))
    commit(types.SET_GROUPS, r.data)
  },
  async getOnboardLookups({ commit, dispatch, state }) {
    let showInactive = false
    let keys = ['StateProvince', 'Country', 'TimeZone', 'Language']
    const r = await startLoading(dispatch, 'getOnboardLookups', () => http.get('lookup/onboardLookups'))
    commit(types.SET_LOOKUPS, [keys, r.data, showInactive])
  },
  async upsertLookup({ commit, dispatch, state }, lookup) {
    const r = await startLoading(dispatch, 'upsertLookup', () => http.post('lookup/Upsert', lookup))
    commit(types.UPSERT_LOOKUP, [lookup, r.data])
    return r
  },
  async deleteLookup({ commit, dispatch, state }, lookup) {
    let _lookup = Object.assign({}, lookup)
    _lookup.isActive = false
    const r = await startLoading(dispatch, 'deleteLookup', () => http.post('lookup/Delete', _lookup))
    if (r.data[0].Results === '') {
      commit(types.DELETE_LOOKUP, lookup)
    }
    return r
  },
  async upsertGroup({ commit, dispatch, state }, { id, name }) {
    let data = {
      id: id,
      text: name
    }
    const r = await startLoading(dispatch, 'deleteLookup', () => http.post('lookup/UpsertGroup', data))
    if (r.data === id) {
      commit(types.UPSERT_GROUP, data)
    }
    return r
  },
  async setCountries({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'setTimeZones', () => http.get('lookup/Countries'))
    let _data = globals.sortArray(r.data)
    commit(types.SET_COUNTRIES, _data)
  },
  async setTimeZones({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'setTimeZones', () => http.get('lookup/TimeZones'))
    let _data = globals.sortArray(r.data)
    commit(types.SET_TIMEZONES, _data)
  },
  async setStateProvinces({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'setStateProvinces', () => http.get(`lookup/StateProvince?id=${id}`))
    let _data = globals.sortArray(r.data)
    commit(types.SET_STATE_PROVINCES, _data)
  },
  async setLanguages({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'setLanguages', () => http.get('lookup/Languages'))
    let _data = globals.sortArray(r.data)
    commit(types.SET_LANGUAGES, _data)
  },
  async getCountryCode({ state }, id) {
    let code = null
    state.lookups['Country'].forEach((element) => {
      if (parseInt(element.value) === parseInt(id)) {
        code = element.code
      }
    })
    return code
  },
  async getStateProvinceAbbr({ state }, id) {
    let abbr = null
    state.lookups['StateProvince'].forEach((element) => {
      if (parseInt(element.value) === parseInt(id)) {
        abbr = element.name
      }
    })
    return abbr
  },
  async getKeywords({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getKeywords', () => http.get(`lookup/keywords?types=${data.keys}&vehicleMake=${data.vehicleMake}`))
    commit(types.SET_LOOKUPS, [data.keys, r.data, false])
  },
  async getBrand({ dispatch, commit }, data) {
    let items = {
      firm: data.firm,
      category: 'Brand',
      refresh: true
    }
    const r = await startLoading(dispatch, 'getBrand', () =>
      http.get('firm/firmPreference', {
        params: items
      })
    )
    commit(types.SET_BRAND, r.data)
    return r.data
  },
  async getInsurance({ dispatch, commit }, firm) {
    if (firm === null || firm === undefined) {
      firm = 1
    }
    const r = await startLoading(dispatch, 'getInsurance', () => http.get(`lookup/insurance?firm=${firm}`))
    commit(types.SET_INSURANCE, r.data)
  },
  async saveInsurance({ dispatch, commit }, data) {
    const r = await startLoading(dispatch, 'saveInsurance', () => http.post('lookup/insurance', data))
    return r.data
  },
  async deleteInsurance({ dispatch, commit }, id) {
    const r = await startLoading(dispatch, 'deleteInsurance', () => http.get(`lookup/removeInsurance?id=${id}`))
    return r.data
  },
  async getInsuranceLookups({ dispatch, commit }, insurance) {
    const r = await startLoading(dispatch, 'getInsuranceLookups', () => http.get(`lookup/insuranceLookup?insurance=${insurance}`))
    commit(types.SET_INSURANCE_LOOKUP, r.data)
  },
  async saveInsuranceLookup({ dispatch, commit }, data) {
    const r = await startLoading(dispatch, 'saveInsuranceLookup', () => http.post('lookup/insuranceLookup', data))
    return r.data
  },
  async deleteInsuranceLookup({ dispatch, commit }, id) {
    const r = await startLoading(dispatch, 'deleteInsuranceLookup', () => http.get(`lookup/removeInsuranceLookup?id=${id}`))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/actions.js